const btnExpiredServices = {
  label: 'filters',
  Typography: 'No results found'
};

export default btnExpiredServices;
